import { render, staticRenderFns } from "./tabOne.vue?vue&type=template&id=0e881408&scoped=true"
import script from "./tabOne.vue?vue&type=script&lang=js"
export * from "./tabOne.vue?vue&type=script&lang=js"
import style0 from "./tabOne.vue?vue&type=style&index=0&id=0e881408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e881408",
  null
  
)

export default component.exports